<template>
    <confirmation-page-layout :company="company" :loaded="loaded" :tourlead="tourlead">
        <template v-slot:breadcrumbs>
            <tour-breadcrumbs :search-request="searchRequest" />
        </template>
        <template v-slot:sidebar>
            <tour-search-summary search-disabled :search-request="searchRequest" />
            <tour-order-summary :offer="offer" />
        </template>
    </confirmation-page-layout>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import ConfirmationPageLayout from '@/components/parts/ConfirmationPageLayout.vue'
    import {ConfirmationPageMixin} from '@/mixins/ConfirmationPageMixin.vue'
    import TourBreadcrumbs from '@/components/tours/TourBreadcrumbs.vue'
    import TourSearchSummary from '@/components/tours/search/TourSearchSummary.vue'
    import TourOrderSummary from '@/components/tours/booking/TourOrderSummary.vue'
    import {TourPageMixin} from '@/components/tours/mixins/TourPageMixin.vue'

    @Component({
        components: {TourOrderSummary, TourSearchSummary, TourBreadcrumbs, ConfirmationPageLayout},
        async setup() {
            return await useConfirmationPage()
        },
    })
    export class TourConfirmationPage extends mixins(ConfirmationPageMixin, TourPageMixin) {
        get packageTourId() {
            return this.searchRequest.packageTourId
        }

        get searchRequest() {
            return this.basketItem.searchRequest
        }

        get basketItem() {
            return toursStore.basketItem(toursStore.prepareBookRequest.offerKey)
        }

        get offer() {
            return this.basketItem.offer
        }
    }

    export default TourConfirmationPage
</script>
